import React, { useRef } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  Datagrid,
} from 'react-admin';
import { useHistory } from 'react-router-dom';

import { Card, makeStyles } from '@material-ui/core';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import ListIcon from '@material-ui/icons/List';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_COTACOES_LISTAR } from '../../utils/dadosTelas';
import DialogoCreateCotacao from '../Cotacoes/DialogoCreate';
import Dialogo from './DialogoCreateEdit';
//import ActionsField from './Fields/ActionsField';

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    // backgroundColor: '#f8f8f8',
    padding: '10px',
    // color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    // borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

//
const MyList = ({ ...props }) => {
  const refDialogo = useRef(null);
  const refDialogoCreateCotacao = useRef(null);
  const refresh = useRefresh();
  const classes = useStyles();
  const history = useHistory();

  function handleCriar() {
    if (refDialogo.current) {
      refDialogo.current.handleCreate();
    }
  }

  function handleEdit({ id }) {
    if (refDialogo.current) {
      refDialogo.current.handleEdit(id);
    }
  }

  function handleCreateCotacao({ id }) {
    if (refDialogoCreateCotacao.current) {
      refDialogoCreateCotacao.current.handleOpen(id);
    }
  }

  function handleCotacoes({ id }) {
    history.push(`/cotacoes?cotacao_template_id=${id}`);
  }

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <Title title="Cotações Templates" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField
            source="nome"
            label="Nome"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ActionsField
            source="valor"
            textAlign="right"
            label="Ações"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            /*      handleListCotacoes={handleCotacoes}
            handleEdit={handleEdit}
            handleCotacao={handleCreateCotacao}
            ativo */
            actions={[
              {
                key: 'edit',
                title: 'Editar',
                icon: <EditOutlinedIcon />,
                onClick: (rec) => handleEdit(rec),
                show: () => true,
                disabled: () => false,
              },
              {
                key: 'listCotacoes',
                title: 'Listagem Cotações',
                icon: <ListIcon />,
                onClick: (rec) => handleCotacoes(rec),
                show: () => true,
                disabled: () => false,
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <Dialogo ref={refDialogo} handleClose={handleClose} />
      <DialogoCreateCotacao
        ref={refDialogoCreateCotacao}
        handleClose={handleClose}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_COTACOES_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      title="Cotações"
      component="div"
    />
  </ProtegerPagina>
);

export default List2;
